import React, { Component } from "react"
import styled from "styled-components"

import { SECONDARY_TEXT, ACTIVE_TEXT } from "./consts/colors"
import AddtoSlack from "./AddtoSlack"

const SectionCalloutWrapper = styled.div`
  display: flex;
  background-color: ${ACTIVE_TEXT};
  background-image: url(${props => props.background});
  background-size: ${props => props.backgroundSize};
  background-position: ${props => props.backgroundPosition};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 230px;
  padding: 50px 0px;
  width: 100%;
  margin-top: 50px;

  @media (max-width: 768px) {
    display: none;
  }
`
const SectionCalloutContent = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;

  @media (max-width: 980px) {
    width: 95%;
  }
`
const SectionCalloutTitle = styled.h2`
  margin-bottom: 20px;
  color: white;
`

const SectionBlockCopy = styled.p`margin-bottom: 20px;`

const SectionBlockProTip = styled.p`
  color: ${SECONDARY_TEXT};
  margin-bottom: 40px;
`

const SectionCallout = props => (
  <SectionCalloutWrapper
    background={props.background}
    backgroundSize={props.backgroundSize}
    backgroundPosition={props.backgroundPosition}>
    <SectionCalloutContent>
      <SectionCalloutTitle>{props.title}</SectionCalloutTitle>
      <AddtoSlack darkShadow />
    </SectionCalloutContent>
  </SectionCalloutWrapper>
)

export default ({ title, background, backgroundSize, backgroundPosition }) => (
  <SectionCallout
    title={title}
    background={background}
    backgroundSize={backgroundSize}
    backgroundPosition={backgroundPosition}
  />
)



// WEBPACK FOOTER //
// ./src/components/SectionCallout.js